export default __webpack_public_path__ + "static/media/manual03.4dda144e.png";